import { render, staticRenderFns } from "./BemorForm.vue?vue&type=template&id=56000ddc"
import script from "./BemorForm.vue?vue&type=script&lang=js"
export * from "./BemorForm.vue?vue&type=script&lang=js"
import style0 from "./BemorForm.vue?vue&type=style&index=0&id=56000ddc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports